import { render, staticRenderFns } from "./TaskTypeNewModal.vue?vue&type=template&id=18a79f62&"
import script from "./TaskTypeNewModal.vue?vue&type=script&lang=ts&"
export * from "./TaskTypeNewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports